export const messages =  {
  en: {
    supplierCoupon: {
      title: 'Supplier Coupon Management',
      searchConditions: 'Search Conditions',
      couponInfo: 'Coupon Information',
      name: 'Name',
      businessId: 'Business ID',
      supplier: 'Supplier',
      thirdPartyId: 'Third-party ID',
      price: 'Price',
      remark: 'Remark',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      cancel: 'Cancel',
      deleteConfirm: 'Are you sure to delete this coupon?',
      deleteTitle: 'Confirm Operation',
      required: 'Required',
      addTitle: 'Add Coupon',
      editTitle: 'Edit Coupon',
      search: 'Search',
      noData: 'No data',
      supplierRequired: 'Please select a supplier first',
      fetchError: 'Failed to fetch supplier coupon data',
      page: {
        subtitle: 'Manage coupons offered by each supplier and third-party channels',
        empty: 'No supplier coupon data',
        loadFailed: 'Failed to load supplier coupon list',
        noSupplier: 'No supplier available'
      }
    }
  },
  zh: {
    supplierCoupon: {
      title: '供应商优惠券管理',
      searchConditions: '查询条件',
      couponInfo: '优惠券信息',
      name: '名称',
      businessId: '业务ID',
      supplier: '供应商',
      thirdPartyId: '三方ID',
      price: '售价',
      remark: '备注',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirm: '确认',
      cancel: '取消',
      deleteConfirm: '确定删除优惠券？',
      deleteTitle: '请确认您的操作',
      required: '必填',
      addTitle: '添加优惠券',
      editTitle: '修改优惠券',
      search: '查询',
      noData: '暂无数据',
      supplierRequired: '请先选择供应商',
      fetchError: '获取供应商优惠券数据失败',
      page: {
        subtitle: '管理各供应商提供的优惠券与第三方渠道',
        empty: '暂无供应商优惠券数据',
        loadFailed: '获取供应商优惠券列表失败',
        noSupplier: '暂无供应商'
      }
    }
  }
}